import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { Map } from 'immutable';

import Button from '@Components/Button';


export function getClickHandler(spec) {
  const {
    item,
    isActive,
    setSorting,
    buttonOrderValue,
    isTgitemsContext,
  } = spec;

  if (isActive) {
    return (e) => {
      e.preventDefault();
      e.stopPropagation();
    };
  }

  const nextValue = !isTgitemsContext ?
    item.get('value') :
    buttonOrderValue;

  return (e) => {
    e.preventDefault();
    e.stopPropagation();
    setSorting(nextValue, buttonOrderValue);
  }
}

export default function OrderButton (props) {
  const {
    item,
    icon,
    order,
    size,
    setSorting,
    buttonOrderValue,
    isTgitemsContext,
    ...otherProps
  } = props;
  const isActive = buttonOrderValue === order;
  const clickHandler = getClickHandler({
    item,
    isActive,
    setSorting,
    isTgitemsContext,
    buttonOrderValue,
  });

  return (
    <Button
      {...otherProps}
      onClick={clickHandler}
      buttonConfig={{
        className: classnames('result-toolbar-sort-by-order-button', { active: isActive }),
        type: 'link',
        size: size,
        e2eName: 'order',
        iconOnly: true,
        ariaLabel: 'Sort by order',
      }}
      iconConfig={{
        name: icon,
        size: size
      }}
    />
  );
}

OrderButton.propTypes = {
  item: PropTypes.instanceOf(Map).isRequired,
  icon: PropTypes.string.isRequired,
  order: PropTypes.string.isRequired,
  setSorting: PropTypes.func.isRequired,
  buttonOrderValue: PropTypes.string.isRequired,
  isTgitemsContext: PropTypes.bool.isRequired,
};
